export enum Role {
    NONE = "ROLE_NONE",
    USER = "ROLE_USER",
    ADMIN = "ROLE_ADMIN",
}